import React, { useEffect, useState, useContext } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Topbar from './Topbar';
import { UserContext } from './UserContext';

const ManageRole = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const { userData } = useContext(UserContext);
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('authToken');
  //console.log(token); return false;
  const userId = localStorage.getItem('userId');
  const [searchText, setSearchText] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [checkedItems, setCheckedItems] = useState({});
  const [role, setRole] = useState();
  const [notice, setNotice] = useState();
  const [details, setRoleDetails] = useState();
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();

  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  const handleChange = (id) => {
    setCheckedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleRoleChange = async (val) => {
  setRole(val);
  setLoading(true);

  try {
    const response = await axios.get(`${baseUrl}auth/getRoleDetails?role=${val}`, config);
    
    const data = response.data?.data || [];

    const newCheckedItems = {};
    data.forEach((id) => {
      newCheckedItems[id] = true;
    });

    setCheckedItems(newCheckedItems);
    setRoleDetails(data);

  } catch (error) {
    console.error("Error fetching role details:", error);
    setCheckedItems({});
    setRoleDetails([]);
  } finally {
    setLoading(false);
  }
};

  const handleSubmit = async () => {
    const selectedIds = Object.keys(checkedItems).filter(
      (id) => checkedItems[id]
    );
    if(selectedIds.length==0){
      alert("Select menu items to proceed"); return false;
    }
    if(!role || role==="undefined"){
      alert("Select a role to proceed"); return false;
    }

    try {
      const response = await axios.post(baseUrl+'auth/saveRoles', {
        selectedIds,
        role
      }, config);
    //console.log(response.data.success); return false;
    if(response.data.success){
      setNotice("Data Saved Successfully");
      //alert("Data Saved Successfully");
    }
    } catch (err) {
      console.log(err);
      //setError('Invalid Credentials!!');
    }
    //alert("Selected IDs: " + selectedIds.join(", "));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  };

  const userTypeLabels = {
  "0": "ZADM - Admin Purchases",
  "1": "ZCAP - Capital Purchase",
  "2": "ZCON - Consignment Purchase",
  "3": "ZDOM - Domestic Purchase",
  "4": "ZHSD - HSD Purchase Order",
  "5": "ZIMP - Import Purchase",
};

  useEffect(() => {
      console.log(userData);
    const fetchPRs = async () => {
      try {
        const response = await axios.get(baseUrl+'auth/allMenus?user_id='+userId, config);
        const data = response.data?.data || [];
        console.log(data);
        setMenus(data);
      } catch (error) {
        setMenus([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPRs();
  }, []);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await axios.get(baseUrl+'auth/allRoles?user_id='+userId, config);
        const data1 = response.data?.data || [];
        console.log(data1);
        setRoles(data1);
      } catch (error) {
        setRoles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, []);


  const columns = [
    {
      name: '#',
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      width: '60px',
    },
    { name: 'PR', selector: row => row.PurchaseRequisition, sortable: true },
    { name: 'PR Type', selector: row => userTypeLabels[row.PurchaseRequisitionType] 
                   ?? row.PurchaseRequisitionType },
    { name: 'Description', selector: row => row.PurReqnDescription },
    { name: 'Note', selector: row => row.PurReqnHeaderNote },
    {
      name: 'Actions',
      cell: row => (
        <button
          onClick={() => navigate(`/projectdetails/${row.PurchaseRequisition}`)}
          style={{
            padding: '5px 10px',
            border: 'none',
            background: '#007bff',
            color: '#fff',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          View Details
        </button>
      )
    }
  ];

  return (
    <>
      <Topbar />
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="row page-titles">
            <div className="col-md-5 align-self-center">
              <h4 className="text-themecolor">User Role Management</h4>
            </div>
            <div className="col-md-7 align-self-center text-end">
              <div className="d-flex justify-content-end align-items-center">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                  <li className="breadcrumb-item active">User Role Management</li>
                </ol>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <select name='roles' className='form-control' onChange={(e) => handleRoleChange(e.target.value)} style={{width: "200px"}}>
                    <option value="">--Select Role--</option>
                  {/* <option value={2} id={2}>Purchase Enquiry</option>
                  <option value={1} id={1}>Purchase Order</option>
                  <option value={5} id={5}>Miro Print</option>
                  <option value={6} id={6}>Store</option>
                  <option value={7} id={7}>Material</option>
                  <option value={3} id={3}>Admin</option>
                  <option value={4} id={4}>Super Admin</option> */}
                  {roles.map((item, index)=>
                  <option key={index} value={item.id}>{item.roles}</option>
                  )};
                  </select>
                  <span style={{fontSize: '15px', color: "red"}}>{notice ? notice : ""}</span>
                   {menus.map((item) => (
            <label key={item.id} style={{margin: "10px"}}>
              <input
                type="checkbox" id={item.id}
                checked={!!checkedItems[item.id]}
                onChange={() => handleChange(item.id)}
              />
              {item.menu}
            </label>

                   ))}
                   <input type='button' value="Save" onClick={handleSubmit} style={{
            padding: '5px 10px',
            border: 'none',
            background: '#007bff',
            color: '#fff',
            borderRadius: '4px',
            cursor: 'pointer'
          }} />
                  
                </div>
              </div>
            </div>
          </div>

          {/* Right sidebar left as-is */}
        </div>
      </div>
    </>
  );
};

export default ManageRole;
